/**
 *
 * Recent Deposits Service Constants
 *
 */

import { SERVICE_NAMESPACE } from 'common';

export const URL = (apiUrl) => `${apiUrl}/evaluated_transfers`;

export const NAMESPACE = `${SERVICE_NAMESPACE}/recentDeposits`;

// Trigger a fetch request in sagas
export const SEARCH_REQUEST = `${NAMESPACE}/SEARCH_REQUEST`;

// Current status of the service
export const NOT_ASKED = `${NAMESPACE}/NOT_ASKED`;
export const LOADING = `${NAMESPACE}/LOADING`;
export const SUCCESS = `${NAMESPACE}/SUCCESS`;
export const FAILURE = `${NAMESPACE}/FAILURE`;

// Api result limit
export const PAGE_SIZE = '50';



// WEBPACK FOOTER //
// ./src/services/recentDeposits/constants.js